import React from 'react';
import { Alert, Grid, Paper, Stack, Typography } from '@mui/material';
import BreakdownPanel from '../bie/BreakdownPanel';
import MarginBridge from '../bie/MarginBridge';

type Props = { data?: any };

class SimulationFinancialAnalysisPanel extends React.PureComponent<Props> {
  render() {
    const d = this.props.data || {};
    return (
      <Stack spacing={2}>
        <Alert severity="info">Financial analysis groups revenue, costs, margin bridge and flow breakdowns for executive review.</Alert>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}><BreakdownPanel title="Revenue Breakdown" rows={d.revenue || []} /></Grid>
          <Grid size={{ xs: 12, md: 6 }}><BreakdownPanel title="Cost Breakdown" rows={d.costs || []} /></Grid>
          <Grid size={{ xs: 12 }}><MarginBridge rows={d.bridge || []} /></Grid>
          <Grid size={{ xs: 12 }}><Paper elevation={1} sx={{ p: 2 }}><Typography variant="h6" sx={{ fontWeight: 800 }}>SYSCOHADA / Accounting Statement</Typography><Typography variant="body2" color="text.secondary">Placeholder for accounting statement grid/report.</Typography></Paper></Grid>
        </Grid>
      </Stack>
    );
  }
}
export default SimulationFinancialAnalysisPanel;
